import { render, staticRenderFns } from "./homeworkAnalysis.vue?vue&type=template&id=79383320&scoped=true"
import script from "./homeworkAnalysis.vue?vue&type=script&lang=js"
export * from "./homeworkAnalysis.vue?vue&type=script&lang=js"
import style0 from "./homeworkAnalysis.vue?vue&type=style&index=0&id=79383320&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79383320",
  null
  
)

export default component.exports